import { useRef, useMemo } from 'react';
import type { Performer } from '@shared/schema';

// Custom comparison function for performers, ignoring stageStartTime
const arePerformersEqual = (prevPerformers: Performer[], nextPerformers: Performer[]) => {
  if (prevPerformers.length !== nextPerformers.length) {
    return false;
  }

  for (let i = 0; i < prevPerformers.length; i++) {
    const prevP = prevPerformers[i];
    const nextP = nextPerformers[i];

    // Compare all properties except stageStartTime
    for (const key in prevP) {
      if (key === 'stageStartTime') continue;
      if (prevP[key as keyof Performer] !== nextP[key as keyof Performer]) {
        return false;
      }
    }
  }
  return true;
};

export function useStablePerformers(performers: Performer[]) {
  const stablePerformersRef = useRef(performers);

  // Only update the ref if the performers array has actually changed in a meaningful way
  // (i.e., ignoring stageStartTime changes)
  if (!arePerformersEqual(stablePerformersRef.current, performers)) {
    stablePerformersRef.current = performers;
  }

  return stablePerformersRef.current;
}
